export const normalizeHiringSignalMessage = (errorOrMessage) => {
    const responseData = errorOrMessage?.response?.data || {};
    const code = responseData?.code || errorOrMessage?.code || '';
    const rawMessage = String(
        responseData?.message ||
        responseData?.error ||
        errorOrMessage?.message ||
        errorOrMessage ||
        ''
    ).trim();
    const lowerMessage = rawMessage.toLowerCase();

    if (code === 'PREFERRED_DEPARTMENT_REQUIRED' || lowerMessage.includes('preferred department')) {
        return {
            type: 'profile_action',
            title: 'Preferred department needed',
            message: 'Add your preferred department in your profile so we can find accurate hiring signals for your target role.',
            actionLabel: 'Update profile',
            actionPath: '/profile?onboarding=true'
        };
    }

    if (lowerMessage.includes('insufficient credits') || responseData?.required || responseData?.current !== undefined) {
        return {
            type: 'billing_action',
            message: 'You need more credits to search for new hiring signals. Please add credits or try again after your credits refresh.'
        };
    }

    if (lowerMessage.includes('rate limit') || lowerMessage.includes('too many request')) {
        return {
            type: 'retry_later',
            message: 'Hiring signal search is temporarily rate limited. Please wait a bit and try again.'
        };
    }

    if (
        lowerMessage.includes('network') ||
        lowerMessage.includes('timeout') ||
        lowerMessage.includes('querysrv') ||
        lowerMessage.includes('temporarily unavailable')
    ) {
        return {
            type: 'retry_later',
            message: 'Hiring signal search is temporarily unavailable. Please try again later.'
        };
    }

    return {
        type: 'retry_later',
        message: rawMessage || 'Hiring signal search could not be completed. Please try again.'
    };
};

export const normalizeRecruiterSearchMessage = (errorOrMessage) => {
    const responseData = errorOrMessage?.response?.data || {};
    const rawMessage = String(
        responseData?.message ||
        responseData?.error ||
        errorOrMessage?.message ||
        errorOrMessage?.error ||
        errorOrMessage ||
        ''
    ).trim();
    const lowerMessage = rawMessage.toLowerCase();

    if (rawMessage === 'EMPLOYEES_NOT_FOUND' || rawMessage === 'NO_ORG_ID' || lowerMessage.includes('no_org_id')) {
        return 'No verified recruiter contacts are available for this company yet. Please try another company or check back later.';
    }

    if (lowerMessage.includes('no verified recruiter') || lowerMessage.includes('not available for this company')) {
        return 'No verified recruiter contacts are available for this company yet. Please try another company or check back later.';
    }

    if (errorOrMessage?.error === 'QuotaExceeded' || lowerMessage.includes('quota')) {
        return 'Recruiter search credits are unavailable right now. Please add credits or try again later.';
    }

    if (errorOrMessage?.error === 'RateLimited' || lowerMessage.includes('rate limit') || lowerMessage.includes('too many request')) {
        return 'Recruiter search is temporarily rate limited. Please wait a bit and try again.';
    }

    if (
        lowerMessage.includes('buffering timed out') ||
        lowerMessage.includes('querysrv') ||
        lowerMessage.includes('etimeout') ||
        lowerMessage.includes('network') ||
        lowerMessage.includes('timeout')
    ) {
        return 'Recruiter search is temporarily unavailable. Please try again later.';
    }

    return rawMessage || 'Recruiter search is temporarily unavailable. Please try again later.';
};
